import { render, staticRenderFns } from "./DescriptionLine.vue?vue&type=template&id=8686127a"
import script from "./DescriptionLine.vue?vue&type=script&lang=js"
export * from "./DescriptionLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports